import {Injectable} from '@angular/core';
import {CustomToastService} from "../custom-toast.service";
import {TranslateService} from "@ngx-translate/core";


@Injectable({
  providedIn: 'root'
})
export class ValidationHelperService {

  private readonly _emailPattern = "^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$";
  private readonly _abonummerPattern = /7\d{5}$|7\d{6}$|7\d{5}-0\d$|7\d{6}-0\d$|7\d{5}-\d$|7\d{6}-\d$/;
  private readonly _strasseHausnummerPattern = /^(?=.*\d)[a-zA-ZäöüÄÖÜßẞ\s\d!"§$%&/()=?´`+*~'#-_.:,;]+ \d.*$/;
  private readonly _telefonnummerPattern = /^[\d\s()+]+$/;

  constructor(private readonly customToast: CustomToastService, public translate: TranslateService) { }

  get emailPattern(): string {
    return this._emailPattern;
  }

  get abonummerPattern(): RegExp {
    return this._abonummerPattern;
  }

  get strasseHausnummerPattern(): RegExp {
    return this._strasseHausnummerPattern;
  }

  get telefonnummerPattern(): RegExp {
    return this._telefonnummerPattern;
  }

  // toast is only displayed if c is actually passed to the funciton
  isEmailValid(email: string, showToast = false): boolean {
    if (email === null || email === undefined){
      this.customToast.showError(
        this.translate.instant('AUTHENTICATION.FORM_ERRORS.EMAIL_MISSING')
      );
      return false
    }
    const isValid = (email.match(this._emailPattern) !== null);
    if(!isValid){
      if (showToast) {
        this.customToast.showError(
          'Ungültige Email: ' + email
        );
      }
    }
    return isValid;
  }



}
